module.exports = __webpack_public_path__ + "img/DE00163.38bbbcc5.png";